
/**
 * 프로젝트 메타 정보
 */
export type GetProjects200PageAllOfThreeContentItemMetaInfo = {
  tags?: string[];
};
